import React from "react";
import { useUrl } from "..";

export const useLocalPath = (path) => {
    const url = useUrl()
    return `/${url}/${path}`
}